import {useInfiniteQuery} from '@tanstack/react-query';
import {getMyInquiryList} from '@/api/help/my-inquiry';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {getNextPageNo} from '@/utils/help';
import {formatMyInquiry} from '@/utils/help/inquiry';

export const myInquiryListInfinityQueryKey = ['help', 'my-inquiry', 'infinity'];

export const useGetMyInquiryListInfinity = () => {
  const {isMobile} = useHelpContext();
  return useInfiniteQuery({
    queryKey: myInquiryListInfinityQueryKey,
    queryFn: ({pageParam}) => getMyInquiryList({page: pageParam}),
    select: ({pages}) => ({
      inquiryList: pages
        .map(({data}) =>
          data.qnaList.map((inquiry) => formatMyInquiry(inquiry, true)),
        )
        .flat(),
    }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      getNextPageNo(lastPage.data?.pageNo, lastPage.data?.qnaListCount),
    staleTime: 0,
    enabled: isMobile,
  });
};
